import { Button } from "@blueprintjs/core";
import React, { Component } from 'react';
import { DropTarget } from 'react-dnd';
import { DNDTypes } from './DNDTypes';
import { WIN_SIZE_MIN } from './WindowConfig';
import WindowContainer from './WindowContainer';
import data from './windowData.json';

class WindowManager extends Component {
	state = {
		lastZ: 51,
		windows: data
	}

	funcActions = (name) => {
		//console.log("[WindowManager] name);
		switch (name) {
			case "customer_submit":
				console.log("CUSTOMER SUBMIT");
				break;
			case "customer_cancel":
				console.log("CUSTOMER CANCEL");
				break;
			case "business_accept":
				console.log("BUSINESS ACCEPT");
				break;
			case "business_update":
				console.log("BUSINESS UPDATE");
				break;
			case "business_cancel":
				console.log("BUSINESS CANCEL");
				break;
			case "partner_save":
				console.log("PARTNER SAVE");
				break;
			case "partner_exit":
				console.log("PARTNER EXIT");
				break;
			default:
				console.log("DEFAULT");
		}
	}

	funcaddWindow = () => {
		//console.log("[WindowManager] add window");
		let newWin = {
			title: "Partner",
			fields: [
				"Name",
				"Type",
				"Phone"
			],
			buttons: [
				"Save",
				"Exit"
			],
			actions: [
				"partner_save",
				"partner_exit"
			],
			xLeft: 630,
			yTop: 80,
			size_w: 400,
			size_h: 300,
			og_size_w: 400,
			og_size_h: 300,
			zIndex: 49
		}

		let newStt = Object.assign({}, this.state);
		let newWnz = newStt.windows;

		newWnz.push(newWin);
		this.setState({ windows: newWnz });
	}

	funcRemoveWindow = (index) => {
		//console.log("[WindowManager] rmv window ", index);
		let aaa = Object.assign({}, this.state);
		let wintmpo = aaa.windows;
		wintmpo.splice(index, 1);
		this.setState({ windows: wintmpo });
	}

	funcResize = (index, mode) => {
		//console.log("[WindowManager] resize window ", index);
		let rsz = Object.assign({}, this.state);
		let winrsz = rsz.windows;
		let newSz = (!mode ? WIN_SIZE_MIN : this.state.windows[index].og_size_h);

		winrsz[index] = {
			title: this.state.windows[index].title,
			xLeft: this.state.windows[index].xLeft,
			yTop: this.state.windows[index].yTop,
			size_w: this.state.windows[index].size_w,
			size_h: newSz,
			og_size_w: this.state.windows[index].og_size_w,
			og_size_h: this.state.windows[index].og_size_h,
			fields: this.state.windows[index].fields,
			buttons: this.state.windows[index].buttons,
			actions: this.state.windows[index].actions,
			zIndex: this.state.windows[index].zIndex + 2
		}
		this.setState({ windows: winrsz });
	}

	funcMoveZ = (index) => {
		//console.log("[WindowManager] move up ", index);
		let tmp = Object.assign({}, this.state);
		let win = tmp.windows;
		win.forEach((w, i) => {
			w.zIndex = 50 + i;
		});
		win[index] = {
			title: this.state.windows[index].title,
			xLeft: this.state.windows[index].xLeft,
			yTop: this.state.windows[index].yTop,
			size_w: this.state.windows[index].size_w,
			size_h: this.state.windows[index].size_h,
			og_size_w: this.state.windows[index].og_size_w,
			og_size_h: this.state.windows[index].og_size_h,
			fields: this.state.windows[index].fields,
			buttons: this.state.windows[index].buttons,
			actions: this.state.windows[index].actions,
			zIndex: this.state.windows[index].zIndex + win.length
		}
		this.setState({ windows: win });
	}

	funcMoveWindow = (index, x, y) => {
		//console.log("[WindowManager] move window ", index);
		let new_state = Object.assign({}, this.state);
		let wins = new_state.windows;

		const snappedX = Math.round(x / 16) * 16
		const snappedY = Math.round(y / 16) * 16

		wins[index] = {
			title: this.state.windows[index].title,
			xLeft: snappedX,
			yTop: snappedY,
			size_w: this.state.windows[index].size_w,
			size_h: this.state.windows[index].size_h,
			og_size_w: this.state.windows[index].og_size_w,
			og_size_h: this.state.windows[index].og_size_h,
			fields: this.state.windows[index].fields,
			buttons: this.state.windows[index].buttons,
			actions: this.state.windows[index].actions,
			zIndex: this.state.windows[index].zIndex + 1
		}
		this.setState({ windows: wins });
	}

	render() {
		const { connectDropTarget, hovered } = this.props;

		return connectDropTarget(
			<div className={"WindowManager" + (hovered === true ? " Hover" : "")}>
				<Button icon="plus" onClick={this.funcaddWindow} />

				{this.state.windows.map(
					(win, index) =>
						<WindowContainer
							index={index}
							key={index}
							window={win}
							zIndex={win.zIndex}
							funcMoveZ={this.funcMoveZ}
							funcResize={this.funcResize}
							funcRemoveWindow={this.funcRemoveWindow}
							xLeft={win.xLeft}
							yTop={win.yTop}
							size_w={win.size_w}
							size_h={win.size_h}
							buttons={win.buttons}
							actions={win.actions}
							funcActions={this.funcActions}
							fieldData={win.fields}
						/>
				)}
			</div>
		);
	}
}


const dropSource = {
	drop: function (props, monitor, component) {
		const item = monitor.getItem();
		//console.log(item); // dragging
		//console.log(component); //drop target
		//console.log(monitor);

		//if (monitor.isOver()) {
		//console.log("monitor.isOver");
		//}

		//const started = monitor.getInitialClientOffset();
		const sub = monitor.getInitialSourceClientOffset();
		const delta = monitor.getDifferenceFromInitialOffset();
		const calc_x = delta.x + (sub.x);
		const calc_y = delta.y + (sub.y);
		component.funcMoveWindow(item.index, calc_x, calc_y);
	},
	//hover: function (props, monitor, component) {
	//console.log("hovering over background");
	//}
}

function dropCollect(connect, monitor) {
	//console.log("dropCollect");
	return {
		connectDropTarget: connect.dropTarget(),
		hovered: monitor.isOver({ shallow: true })
	}
}

export default DropTarget(DNDTypes.WINDOW, dropSource, dropCollect)(WindowManager);



// WEBPACK FOOTER //
// ./src/components/windowed/WindowManager.js